export const isValidEmail = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

export const isValidNpub = (npub: string): boolean => {
    return npub.length > 0;
};
